import { Pipe, PipeTransform } from '@angular/core';
import { ConsultationStatus } from '@wellro/models';
import { transformConsultationStatus } from '@wellro/transformers';
@Pipe({
  name: 'consultationStatus',
})
export class ConsultationStatusPipe implements PipeTransform {
  transform(value: ConsultationStatus): string {
    return transformConsultationStatus(value);
  }
}
